/**
 * The sign-in's errors, kept apart from authClient.ts so the page can check
 * for them without loading MSAL, which is its own chunk (Bootstrap.tsx).
 */

/** The sign-in needs Microsoft again; nothing was sent (#252; ADR 0093). */
export class SessionRenewalNeededError extends Error {
  override name = "SessionRenewalNeededError";

  constructor() {
    super("Your sign-in needs renewing.");
  }
}

/** The browser didn't let the sign-in popup open. */
export class PopupBlockedError extends Error {
  override name = "PopupBlockedError";

  constructor() {
    super("The browser blocked the sign-in window.");
  }
}

/** A sign-in, renewal or sign-out is already on its way to Microsoft: MSAL
 * starts one at a time, so a second click is refused (#865). */
export class SignInUnderWayError extends Error {
  override name = "SignInUnderWayError";

  constructor() {
    super("Already on the way to Microsoft.");
  }
}
